import React, { useState } from "react";

// @material-ui core components
import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

// Annotation Portal React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Custom styles
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";

// Context
import { useLanguage } from "context/LanguageContext";

const languages = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "es", name: "Español", flag: "🇪🇸" },
];

function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const [languageMenu, setLanguageMenu] = useState(null);

  const handleOpenLanguageMenu = (event) => setLanguageMenu(event.currentTarget);
  const handleCloseLanguageMenu = () => setLanguageMenu(null);

  const handleLanguageChange = (langCode) => {
    if (langCode !== language) {
      setLanguage(langCode);
    }
    handleCloseLanguageMenu();
  };

  const currentLanguage = languages.find((lang) => lang.code === language);

  return (
    <>
      <IconButton
        size="small"
        color="inherit"
        sx={navbarIconButton}
        onClick={handleOpenLanguageMenu}
      >
        <Icon sx={{ fontSize: "1.25rem" }}>language</Icon>
        <MDTypography
          variant="button"
          fontWeight="medium"
          sx={{ ml: 0.5, display: { xs: "none", sm: "inline-block" } }}
        >
          {currentLanguage?.code.toUpperCase()}
        </MDTypography>
      </IconButton>
      <Menu
        anchorEl={languageMenu}
        anchorReference={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={Boolean(languageMenu)}
        onClose={handleCloseLanguageMenu}
        sx={{ mt: 2 }}
      >
        <MDBox sx={{ minWidth: 120, p: 1 }}>
          {languages.map((lang) => (
            <MDBox
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "8px 12px",
                borderRadius: "6px",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "action.hover",
                },
                backgroundColor: language === lang.code ? "action.selected" : "transparent",
                mb: 0.5,
              }}
            >
              <MDTypography variant="body2" sx={{ mr: 1, fontSize: "1.1rem" }}>
                {lang.flag}
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular">
                {lang.name}
              </MDTypography>
            </MDBox>
          ))}
        </MDBox>
      </Menu>
    </>
  );
}

export default LanguageSwitcher;
